import type { UpdateEvents } from "../../common/types.ts";
import type {
	MpLeague,
	MpMember,
	MpSession,
	MpTeam,
} from "../../common/multiplayerConfig.ts";
import {
	getLobbyState,
	getLocalLid,
	getSession,
	subscribeLobby,
} from "../multiplayer/index.ts";

const updateMultiplayerLobby = async (
	inputs: { id: string },
	updateEvents: UpdateEvents,
) => {
	if (
		updateEvents.includes("firstRun") ||
		updateEvents.includes("multiplayer")
	) {
		let session: MpSession | undefined;
		let league: MpLeague | undefined;
		let members: MpMember[] = [];
		let teams: MpTeam[] = [];
		let localLid: number | undefined;
		// Named mpError rather than errorMessage because viewManager replaces
		// the whole page with a generic error view when a returned object has
		// an errorMessage key, even an undefined one.
		let mpError: string | undefined;

		try {
			session = await getSession();
			if (session) {
				const state = await getLobbyState(inputs.id);
				league = state.league;
				members = state.members;
				teams = state.teams;
				localLid = await getLocalLid(inputs.id);

				// Push-updates whenever anyone joins/claims/starts
				await subscribeLobby(inputs.id);
			}
		} catch (error) {
			mpError = error.message;
		}

		return {
			leagueId: inputs.id,
			session,
			league,
			members,
			teams,
			localLid,
			mpError,
		};
	}
};

export default updateMultiplayerLobby;
